import { useAppContext } from '@/context';
import { logout } from '@/utils/auth';
import { putJson } from '@/utils/fetchOptions';

import { useAuthToken, useAuthUser } from './useAuth';
import { useMutation } from './useMutation';

interface useBrandCreateProps {
  onSuccess: TypeAny;
  brand: {
    name: string;
    url?: string;
    logo_url?: string;
  };
}

export function useBrandCreate({ onSuccess, brand }: useBrandCreateProps) {
  const { setAlert } = useAppContext();
  const token = useAuthToken();
  const user = useAuthUser();

  const { isLoading, mutate, error } = useMutation({
    mutationKey: 'brand-create',
    mutationFn: async () =>
      putJson({
        url: `${process.env.NEXT_PUBLIC_BEATLY_API_URL}/app/v2/team/${user?.team?.team_id}/brand/create`,
        body: {
          name: brand?.name,
          url: brand?.url,
          logo_url: brand?.logo_url
        },
        token
      }).then((response: Api.Brand | ResponseObject) => {
        if ((response as ResponseExpiredToken).isExpired) {
          logout();
        }

        if ('code' in response) {
          setAlert(response.code);
        }

        return response;
      }),
    onSuccess
  });

  return {
    isLoading,
    mutate,
    error
  };
}
